import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { INTRO_PRICING_FLAG_NAME } from '../constants'

export const useExperimentViewed = () => {
  useEffect(() => {
    trackExperimentViewed(INTRO_PRICING_FLAG_NAME)
  }, [])
}
